import {Field} from "formik";
import React, {useState} from "react";
import * as yup from "yup";
import DefaultActionButtonGenerator from "../../../../components/action-buttons/ActionButtonGenerator";
import FormikForm from "../../../../components/crud/FormikForm";
import ListStatus from "../../../../components/list/ListStatus";
import TextArea from "../../../../components/form-fields/TextArea";
import {formatDate, formatShortDate} from "../../../../utils";
import { useTranslation } from "react-i18next";

export default function LastStatus(props) {
    const [refreshList, setRefreshList] = useState(false);
    const [initialValues, setInitialValues] = useState({});
    const {t} = useTranslation();

    const validationSchema = yup.object({});

    const arrangeBeforePersist = (values) => {
        if(values && values.mesaj){
            let payload = {
                "talepId": props.selectedRow.id,
                "mesaj": values.mesaj
            };
            values.mesaj = "";
            return payload;
        } else {
            return null;
        }
    };


    return (
        <div className="row">
            <div className="col-md-12 col-xl-12 col-xxl-12">
                <FormikForm
                    keyField={"statusForm"}
                    endPointUrl="/yonlendirilecek-talep/son-durum-ekle"
                    arrangeBeforePersist={arrangeBeforePersist}
                    validationSchema={validationSchema}
                    refreshList={() => {                        
                        setRefreshList(!refreshList)
                        props.refreshList();                        
                    }}
                    initialValues={initialValues}
                    okButtonText={t("tabs.ekle")}
                    hideFooterHr
                    disableButtons={props.disableButtons}
                >
                    <Field
                        name="mesaj"
                        label={t("tabs.sonDurum")}
                        colNumber="12"
                        component={TextArea}
                    />
                </FormikForm>
            </div>

            <div className="col-md-12">
                <ListStatus
                    entityName=""
                    endpoint="yonlendirilecek-talep/son-durum-listele"
                    keyField="id"
                    refreshList={refreshList}
                    customBody={{
                        id: (props.selectedRow.talep
                            ? props.selectedRow.talep.id
                            : props.selectedRow.id),
                    }}
                    columns={[
                        {
                            dataField: "userDto.fullName",
                            text: t("tabs.ekleyen"),
                            sort: true,
                        },
                        {
                            dataField: "mesaj",
                            text: t("tabs.durum"),
                            sort: true,
                        },
                        {
                            dataField: "createdDate",
                            text: t("tabs.tarih"),
                            formatter: formatDate,
                            sort: true,
                        },
                    ]}
                    actionButtonsObject={{
                        actions: [],
                        generator: DefaultActionButtonGenerator,
                    }}
                />
            </div>
        </div>
    );
}
